import React from 'react';

import ApiService from './../utils/ApiService';

export const DictonaryContext = React.createContext();

export class DictonaryProvider extends React.Component {
  state = {
    dictonary: {},
    loaded: false,
  };

  componentDidMount() {
    ApiService.meta()
      .dictonaries()
      .then(resp => {
        if (resp.status === 200) {
          this.setState({
            dictonary: resp.data.dictonary,
            loaded: true,
          });
        } else {
          throw Error['Dictonary konnte nicht geladen werden.'];
        }
      });
  }

  render() {if (!this.state.loaded) return null;
    return (
      <DictonaryContext.Provider value={this.state.dictonary}>
        {this.props.children}
      </DictonaryContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/context/dictonary-content.js